import { AfterViewInit, Component, ElementRef, HostListener, ViewChild } from '@angular/core';
import { RouterModule } from '@angular/router';
import { TrustedComponent } from "../trusted/trusted.component";
import { CreatorCarouselComponent } from "../creator-carousel/creator-carousel.component";

@Component({
  selector: 'app-home-page',
  imports: [RouterModule, TrustedComponent, CreatorCarouselComponent],
  templateUrl: './home-page.component.html',
  styleUrl: './home-page.component.css'
})
export class HomePageComponent implements AfterViewInit {

  ngAfterViewInit(): void {
    const video = document.querySelector('.home-video') as HTMLVideoElement;
    const phone_video = document.querySelector('.new-phone-video') as HTMLVideoElement;
    if (video) {
      video.muted = true; // Ensure video is muted for autoplay
      const tryPlay = () => {
        video.play().catch((err) => {
          console.warn('Autoplay failed:', err);
        });
      };

      // Slight delay to ensure styles/layout are complete
      setTimeout(tryPlay, 50);
    }

    if (phone_video) {
      phone_video.muted = true; // Ensure video is muted for autoplay
      const tryPlay = () => {
        phone_video.play().catch((err) => {
          console.warn('Autoplay failed:', err);
        });
      };

      // Slight delay to ensure styles/layout are complete
      setTimeout(tryPlay, 50);
    }
  }

}
